function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#F7B52C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#3E3A39;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "XMLID_1064_"
}, React.createElement("polyline", {
  id: "XMLID_1067_",
  className: "st0",
  points: "-220.8,273.3 -120.1,273.3 -120.1,323.3 -220.8,323.3  "
}), React.createElement("g", {
  id: "XMLID_2263_"
}, React.createElement("path", {
  id: "XMLID_2264_",
  className: "st1",
  d: "M-198.8,302.4l7-22.9h5.2v37.6h-3.5v-30.7h-0.1l-6.2,19.9h-5.1l-6.1-19.7v30.5h-3.5v-37.6    h5.3L-198.8,302.4L-198.8,302.4L-198.8,302.4z"
}), React.createElement("path", {
  id: "XMLID_2266_",
  className: "st1",
  d: "M-177.5,317.1h-3.6l8.6-37.6h5.1l8.6,37.6h-3.6l-2.3-10.3h-10.4L-177.5,317.1z M-170,283.7    L-170,283.7c-0.7,3.2-1.5,6.5-2.1,9.6c-0.7,3.2-1.4,6.4-2.1,9.6h8.5L-170,283.7z"
}), React.createElement("path", {
  id: "XMLID_2269_",
  className: "st1",
  d: "M-131.8,279.5v37.6h-5.7l-12.5-30.7h-0.1v30.7h-3.4v-37.6h4.4l13.8,33.2h0.1v-33.2H-131.8z"
})), React.createElement("g", {
  id: "XMLID_2254_"
}, React.createElement("path", {
  id: "XMLID_2255_",
  className: "st2",
  d: "M-292.3,305.9c0,1.5-0.3,3-0.8,4.3c-0.6,1.4-1.3,2.5-2.2,3.5c-0.9,1-2,1.8-3.3,2.4    c-1.3,0.6-2.6,0.9-4.1,0.9c-1.4,0-2.8-0.2-4.2-0.6s-2.6-0.8-3.6-1.3c-1.3-0.6-2.4-1.1-3.5-1.9l1.3-3.5c1.3,0.6,2.5,1.2,3.6,1.7    c1,0.5,2.1,0.8,3.3,1.1c1.1,0.4,2.1,0.5,3.1,0.5c0.9,0,1.8-0.2,2.6-0.6c0.8-0.4,1.5-0.9,2.1-1.5c0.7-0.6,1-1.4,1.4-2.2    c0.4-0.8,0.5-1.8,0.5-2.8s-0.3-1.9-0.7-2.5c-0.5-0.6-1-1.2-1.8-1.7c-0.7-0.5-1.6-0.8-2.4-1c-0.8-0.3-1.8-0.5-2.5-0.6    c-1.4-0.2-2.6-0.6-3.8-1.1c-1.2-0.6-2.2-1.3-3.1-2.1c-0.8-0.8-1.6-1.9-2.1-3.1c-0.6-1.2-0.7-2.5-0.7-4s0.3-2.9,0.8-4.3    c0.6-1.3,1.3-2.5,2.2-3.4c0.9-1,2-1.8,3.3-2.3c1.3-0.5,2.6-0.9,4-0.9c0.8,0,1.8,0.1,2.7,0.3c0.9,0.2,1.8,0.5,2.6,0.6    c0.9,0.3,1.9,0.6,2.8,0.9l-1.2,3.6c-0.8-0.3-1.7-0.6-2.5-0.8c-0.7-0.2-1.5-0.5-2.3-0.6c-0.8-0.1-1.6-0.3-2.3-0.3    c-0.9,0-1.8,0.2-2.5,0.6c-0.7,0.4-1.5,0.9-2,1.6c-0.6,0.6-1,1.4-1.3,2.2c-0.3,0.8-0.5,1.7-0.5,2.6c0,1,0.2,1.9,0.7,2.7    c0.5,0.7,1,1.4,1.7,1.9c0.7,0.6,1.4,0.9,2.1,1.3c0.7,0.3,1.6,0.6,2.2,0.7c1.5,0.3,2.9,0.6,4.2,1.1s2.4,1.1,3.3,1.9    c0.9,0.8,1.7,1.7,2.2,2.8C-292.6,303.2-292.3,304.4-292.3,305.9z"
}), React.createElement("path", {
  id: "XMLID_2257_",
  className: "st2",
  d: "M-287,279.5h3.5v37.6h-3.5V279.5z"
}), React.createElement("path", {
  id: "XMLID_2259_",
  className: "st2",
  d: "M-272.3,307.4c0,0.9,0.2,1.8,0.6,2.6c0.4,0.7,0.8,1.5,1.4,2.1c0.6,0.6,1.3,1.1,2,1.4    c0.7,0.4,1.6,0.5,2.4,0.5c0.4,0,0.8-0.1,1.4-0.2s1.5-0.5,2.7-1.1v-10.1h3.7V315c-2.1,1.1-3.8,1.9-5.2,2.1    c-1.4,0.3-2.2,0.5-2.8,0.5c-1.5,0-2.8-0.3-4-0.9c-1.2-0.6-2.3-1.4-3.2-2.3c-0.9-1-1.6-2.1-2-3.4c-0.4-1.3-0.7-2.8-0.7-4.3v-16.8    c0.2-3.4,1.1-6.1,3-8.1c1.8-1.9,4.2-3,7.2-3c0.6,0,1.2,0.1,1.9,0.3c0.7,0.2,1.4,0.3,2,0.6l3.6,1.4l-1.3,3.8l-4.1-1.6    c-0.8-0.4-1.5-0.6-2.1-0.6c-0.8,0-1.7,0.2-2.5,0.6c-0.7,0.4-1.5,0.9-2,1.6c-0.6,0.6-1,1.4-1.4,2.2c-0.4,0.8-0.5,1.8-0.5,2.7    L-272.3,307.4L-272.3,307.4z"
}), React.createElement("path", {
  id: "XMLID_2261_",
  className: "st2",
  d: "M-229.4,279.5v37.6h-5.7l-12.5-30.7h-0.1v30.7h-3.4v-37.6h4.4l13.8,33.2h0.1v-33.2H-229.4z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "XMLID_1_"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "XMLID_2_"
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  id: "XMLID_3_"
});

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  id: "XMLID_4_"
});

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  id: "XMLID_5_"
});

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  id: "XMLID_6_"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    x: "0px",
    y: "0px",
    viewBox: "-320 273.3 200 50",
    style: {
      enableBackground: "new -320 273.3 200 50"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.619c9402.svg";
export { ForwardRef as ReactComponent };